// extracted by mini-css-extract-plugin
module.exports = {"input-box":"SearchBar_input-box__lm24m","search-icon":"SearchBar_search-icon__2IHu5"};